import RepositoryService from 'src/services/repository'

const resource = 'part'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  getListToUse: params => RepositoryService.crud.getList(`${resource}/to-use`, params),
}
